import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

//styles
import './style.scss';

//antd component
import { Button } from 'antd';

//assets
import CustomIcons from 'components/CustomIcons';

function NoAbsence({
  title,
  content,
  // actions
  newAction,
  filterAction,
  // default
  children,
  className,
  ...rest
}) {
  const childClassName = classNames('no-absence-screen', className);

  return (
    <>
      {title && (
        <div className={childClassName} {...rest}>
          <CustomIcons className="no-absence-screen__icon" type="no-absence" />
          <div className="no-absence-screen__content">
            <h3 className="content-title">{title}</h3>
            {(content || children) && (
              <div
                className="content-text"
                dangerouslySetInnerHTML={{ __html: content || children }}
              />
            )}
          </div>
          <div className="no-absence-screen__actions">
            {newAction !== undefined && (
              <Button type="link" onClick={newAction} className="link-request">
                Nouvelle demande
              </Button>
            )}
            {filterAction !== undefined && (
              <Button type="link" onClick={filterAction} className="link-request">
                Consulter les absences traitées
              </Button>
            )}
          </div>
        </div>
      )}
    </>
  );
}

NoAbsence.defaultProps = {};
NoAbsence.propTypes = {
  title: PropTypes.string.isRequired,
  newAction: PropTypes.func,
  filterAction: PropTypes.func,
};

export default memo(NoAbsence);
